/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 4239:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(2705),
    getRawTag = __webpack_require__(9607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 7561:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var trimmedEndIndex = __webpack_require__(7990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 1957:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 9607:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(2705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5639:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(1957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 7990:
/***/ ((module) => {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 3279:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(3218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(4841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 3218:
/***/ ((module) => {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 7005:
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 3448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(5639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 3493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var debounce = __webpack_require__(3279),
    isObject = __webpack_require__(3218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 4841:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTrim = __webpack_require__(7561),
    isObject = __webpack_require__(3218),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* eslint-disable */
var SIDE_MENU_SORTING_RULE_SELECTOR = '[data-collection-base-side-menu-top-sorting-panel-rule]';
var COLLECTION_DESCRIPTION_DATA_ATTR = '[data-collection-base-header-info-description]';
var COLLECTION_DESCRIPTION_TEXT_DATA_ATTR = '[data-collection-base-header-info-description-text]';
var READ_MORE_DATA_ATTR = '[data-collection-base-header-info-description-read-more]';
var descriptionContainerEl = document.querySelector(COLLECTION_DESCRIPTION_DATA_ATTR);
var descriptionTextEl = document.querySelector(COLLECTION_DESCRIPTION_TEXT_DATA_ATTR);
var descriptionReadMoreButtonEl = document.querySelector(READ_MORE_DATA_ATTR);
var calcCountOfTextLines = function calcCountOfTextLines(container) {
  if (!container) return 0;
  var containerHeight = container.scrollHeight;
  var textLineHeight = parseInt(document.defaultView.getComputedStyle(container, null).getPropertyValue("line-height"));
  return Math.floor(containerHeight / textLineHeight) || 0;
};
var updateReadMoreVisibility = function updateReadMoreVisibility() {
  if (!descriptionTextEl && !descriptionReadMoreButtonEl && !descriptionContainerEl) return false;
  var countOfTextLines = calcCountOfTextLines(descriptionTextEl);
  var countLinesBeforeTrim = Number(descriptionTextEl.getAttribute('data-count-lines-before-trim')) || 0;
  if (countOfTextLines < countLinesBeforeTrim) {
    descriptionReadMoreButtonEl.classList.add('hidden');
    descriptionReadMoreButtonEl.innerHTML = 'Read less';
    descriptionContainerEl.style.maxHeight = 'unset';
    descriptionTextEl.setAttribute('data-active', 'true');
  } else {
    descriptionReadMoreButtonEl.classList.remove('hidden');
    descriptionReadMoreButtonEl.innerHTML = 'Read more';
    descriptionContainerEl.style.maxHeight = '1000px';
    descriptionTextEl.setAttribute('data-active', 'false');
  }
  return true;
};
var readMoreCollectionListener = function readMoreCollectionListener() {
  if (!descriptionTextEl && !descriptionReadMoreButtonEl && !descriptionContainerEl) return false;
  var descriptionContainerHeight = "".concat(descriptionContainerEl.clientHeight, "px");
  descriptionContainerEl.style.maxHeight = "".concat(descriptionContainerHeight);
  descriptionReadMoreButtonEl.addEventListener('click', function () {
    var isReadMoreOpened = descriptionTextEl.getAttribute('data-active') === 'true';
    if (isReadMoreOpened) {
      descriptionContainerEl.style.maxHeight = "".concat(descriptionContainerHeight);
      descriptionTextEl.setAttribute('data-active', 'false');
      descriptionReadMoreButtonEl.innerHTML = 'Read more';
    } else {
      descriptionTextEl.setAttribute('data-active', 'true');
      descriptionReadMoreButtonEl.innerHTML = 'Read less';
      descriptionContainerEl.style.maxHeight = '1000px';
    }
  });
  return true;
};
var initReadMoreDescription = function initReadMoreDescription() {
  readMoreCollectionListener();
  updateReadMoreVisibility();
  window.addEventListener('resize', lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(function () {
    updateReadMoreVisibility();
  }, 250));
};
var OVERLAY_SELECTOR = '[data-filter-overlay]';
var PRODUCTS_CONTAINER_SELECTOR = '[data-collection-base-body-products]';
var PRODUCT_CARD_SELECTOR = '[data-collection-base-body-product]';
var SHOW_MORE_PRODUCTS_BUTTON_SELECTOR = '[data-collection-base-body-more-button]';
var NEXT_PRODUCTS_LIST_URL_ATTR = 'data-collection-base-body-products-pagination-next';
var ACTIVE_ATTR = 'data-active';
var VALUE_ATTR = 'data-value';
var CHANGE_GRID_BUTTON_SELECTOR = '[data-collection-base-side-menu-top-sorting-grid-button]';
var GRID_FORMAT_ATTR = 'data-grid-format';
var PRODUCTS_COUNT_ATTR = 'data-collection-base-body-products-count';
var SIDE_MENU_SELECTOR = '[data-collection-base-side-menu]';
var SIDE_MENU_HIDE_ACTION = '[data-action="hide-filter-area"]';
var SIDE_MENU_SHOW_ACTION = '[data-action="show-filter-area"]';
var SIDE_MENU_TITLE_SELECTOR = '[data-collection-base-side-menu-top-title]';
var FILTER_ACTION = '[data-action="apply-filter"]';
var REMOVE_FILTER_ACTION = '[data-action="remove-active-filter"]';
var REMOVE_PRICE_FILTER_ACTION = '[data-action="remove-active-price-filter"]';
var REMOVE_PRICE_FILTER_TEXT = '[data-collection-base-side-menu-bottom-active-filers-panel-filter-price]';
var REMOVE_ACTIVE_FILTERS_ACTION = '[data-action="remove-active-filters"]';
var APPLY_ACTIVE_FILTERS_ACTION = '[data-action="apply-active-filters"]';
var ACTIVES_FILTER_PARAM_NAME_ATTR = 'data-filter-param-name';
var ACTIVES_FILTER_PARAM_VALUE_ATTR = 'data-filter-param-value';
var PRICE_RANGE_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-price-range]';
var PRICE_RANGE_CONTAINER_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-slider-range-container]';
var PRICE_RANGE_MIN_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-price-range-min]';
var PRICE_RANGE_MAX_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-price-range-max]';
var PRICE_RANGE_FROM_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-price-range-from]';
var PRICE_RANGE_TO_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-price-range-to]';
var FILTER_HEADER_SELECTOR = '[data-collection-base-side-menu-bottom-filters-groups-header]';
var FILTER_VALUE_LABEL_SELECTOR = '[data-collection-base-side-menu-bottom-filters-group-item]';
var LOAD_MORE_BUTTON_SELECTOR = '[data-collection-base-body-more]';
var HEADER_NAV_ATTR = 'data-collection-base-header-nav';
var removeFiltersBtns = document.querySelectorAll(REMOVE_FILTER_ACTION);
var removePriceFilterBtnEl = document.querySelector(REMOVE_PRICE_FILTER_ACTION);
var removePriceFilterBtnTextEl = document.querySelector(REMOVE_PRICE_FILTER_TEXT);
var priceRangeFromEl = document.querySelector(PRICE_RANGE_FROM_SELECTOR);
var priceRangeToEl = document.querySelector(PRICE_RANGE_TO_SELECTOR);
var filtersHeaders = document.querySelectorAll(FILTER_HEADER_SELECTOR);
var overlay = document.querySelector(OVERLAY_SELECTOR);
var sideMenu = document.querySelector(SIDE_MENU_SELECTOR);
var enableLoadingOverlay = function enableLoadingOverlay() {
  if (!document.querySelector('[data-e-loading-more]')) {
    var overlayTemplate = "<div data-e-loading-more class=\"e-loading-more\"></div>";
    document.body.insertAdjacentHTML('beforeend', overlayTemplate);
  }
};
var disableLoadingOverlay = function disableLoadingOverlay() {
  var _document$querySelect;
  (_document$querySelect = document.querySelector('[data-e-loading-more]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.remove();
};
var initChangeGridButtons = function initChangeGridButtons() {
  var GRID_OPTIONS = {
    SMALL: 'small',
    LARGE: 'large'
  };
  var GRID_MOD_LARGE = 'collection-base__body-products--large';
  var changeGridButtons = document.querySelectorAll(CHANGE_GRID_BUTTON_SELECTOR);
  var productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
  changeGridButtons.forEach(function (changeGridButton) {
    changeGridButton.addEventListener('click', function () {
      var gridFormat = changeGridButton.getAttribute(GRID_FORMAT_ATTR);
      changeGridButtons.forEach(function (btn) {
        return btn.setAttribute(ACTIVE_ATTR, 'false');
      });
      changeGridButton.setAttribute(ACTIVE_ATTR, 'true');
      gridFormat === GRID_OPTIONS.LARGE ? productsContainer.classList.add(GRID_MOD_LARGE) : productsContainer.classList.remove(GRID_MOD_LARGE);
    });
  });
};
var getPageFromUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var response, html, parser, page;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);
          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();
          case 5:
            html = _context.sent;
            parser = new DOMParser();
            page = parser.parseFromString(html, 'text/html');
            return _context.abrupt("return", page);
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getPageFromUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();
var updateNextUrlValue = function updateNextUrlValue(page) {
  var productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
  var nextUrlSelector = page.querySelector(PRODUCTS_CONTAINER_SELECTOR);
  var nextUrl = null;

  if (nextUrlSelector) {
    nextUrl = nextUrlSelector.getAttribute(NEXT_PRODUCTS_LIST_URL_ATTR);
  }

  if (nextUrl) {
    productsContainer.setAttribute(NEXT_PRODUCTS_LIST_URL_ATTR, nextUrl);
    return nextUrl; // Retornar a URL, que será avaliada como true em condições booleanas
  } else {
    // Não há mais URLs para carregar
    productsContainer.removeAttribute(NEXT_PRODUCTS_LIST_URL_ATTR);
    return null;
  }
};
var updateProductsListFromUrl = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url) {
    var page, productsContainer, newProductsContainer, newProducts, newProductsCount;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getPageFromUrl(url);
          case 2:
            page = _context2.sent;
            productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
            newProductsContainer = page.querySelector(PRODUCTS_CONTAINER_SELECTOR);
            newProducts = newProductsContainer.querySelectorAll(PRODUCT_CARD_SELECTOR);
            productsContainer.innerHTML = null;
            newProducts.forEach(function (productCard) {
              productsContainer.append(productCard);
            });
            newProductsCount = newProductsContainer.getAttribute(PRODUCTS_COUNT_ATTR);
            productsContainer.setAttribute(PRODUCTS_COUNT_ATTR, newProductsCount);
            if (productsContainer.childNodes.length === Number(newProductsCount)) {
              hideShowMoreProductsButton();
            } else {
              hideShowMoreProductsButton(false);
            }
            return _context2.abrupt("return", page);
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function updateProductsListFromUrl(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
// Array para armazenar todos os produtos fora de estoque encontrados
var outOfStockProducts = [];

// Controle se ainda estamos carregando produtos em estoque
var stillLoadingInStockProducts = true;

// Flag para controlar se todos os produtos já foram carregados
var allProductsLoaded = false;

// Flag para controlar se uma requisição de carregamento está em andamento
var isLoadingProducts = false;

// Função para determinar se um nó é um produto fora de estoque
var isProductOutOfStock = function(node) {
  return node.getAttribute('data-product-soldout') === 'true';
};

var addProductsTilesFromUrl = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
    var productsContainer, page, productsList, inStockProducts, outOfStockProductsInPage, allProductsList, nextUrl;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
            _context3.next = 3;
            return getPageFromUrl(url);
          case 3:
            page = _context3.sent;
            productsList = Array.from(page.querySelectorAll(PRODUCT_CARD_SELECTOR));
            
            // Separar produtos em estoque e fora de estoque
            inStockProducts = productsList.filter(function(node) {
              return !isProductOutOfStock(node);
            });
            
            outOfStockProductsInPage = productsList.filter(isProductOutOfStock);
            
            // Armazenar produtos fora de estoque para exibição posterior
            outOfStockProducts = outOfStockProducts.concat(outOfStockProductsInPage);
            
            // Verificar se não existem mais produtos em estoque para carregar
            if (inStockProducts.length === 0) {
              stillLoadingInStockProducts = false;
            }
            
            // Verificar se há mais páginas para carregar
            nextUrl = updateNextUrlValue(page);
            
            // Se não há próxima URL ou não há produtos em estoque na página atual, 
            // terminamos de carregar todos os produtos em estoque
            if (!nextUrl || inStockProducts.length === 0) {
              stillLoadingInStockProducts = false;
            }
            
            // Se ainda estamos carregando produtos em estoque, mostrar apenas esses
            if (stillLoadingInStockProducts) {
              inStockProducts.forEach(function(node) {
                productsContainer.appendChild(node);
              });
            } else {
              // Se não estamos mais carregando produtos em estoque, 
              // começar a mostrar os produtos fora de estoque
              
              // Exibir todos os produtos em estoque dessa página primeiro
              inStockProducts.forEach(function(node) {
                productsContainer.appendChild(node);
              });
              
              // Depois exibir todos os produtos fora de estoque acumulados
              console.log('Exibindo', outOfStockProducts.length, 'produtos fora de estoque');
              outOfStockProducts.forEach(function(node) {
                productsContainer.appendChild(node);
              });
              
              // Limpar a lista de produtos fora de estoque, já que todos foram exibidos
              outOfStockProducts = [];
              
              // Se não há próxima URL, então acabamos
              if (!nextUrl) {
                allProductsLoaded = true;
              }
            }
            
            // Verificar se já carregamos todos os produtos da collection
            allProductsList = document.querySelectorAll(PRODUCT_CARD_SELECTOR);
            if (allProductsList.length >= Number(productsContainer.getAttribute(PRODUCTS_COUNT_ATTR))) {
              allProductsLoaded = true;
            }
            
            return _context3.abrupt("return", page);
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function addProductsTilesFromUrl(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

// Função para inicializar a página filtrando produtos fora de estoque
var filterOutOfStockProductsOnInitialLoad = function() {
  var productsContainer = document.querySelector('.collection-base__body-products');
  
  if (!productsContainer) {
    return;
  }
  
  var productItems = Array.from(productsContainer.querySelectorAll('.collection-base__body-product'));
  
  if (productItems.length === 0) {
    return;
  }
  
  // Verificar se a coleção tem paginação
  var nextUrl = productsContainer.getAttribute(NEXT_PRODUCTS_LIST_URL_ATTR);
  var hasMultiplePages = !!nextUrl;
  
  // Se a coleção não tiver paginação, não filtrar produtos fora de estoque
  if (!hasMultiplePages) {
    console.log('Coleção sem paginação: produtos fora de estoque serão exibidos normalmente.');
    
    // Registrar produtos já carregados para evitar duplicação
    productItems.forEach(function(item) {
      var productId = item.getAttribute('data-product-id');
      if (productId && loadedProductIds) {
        loadedProductIds.add(productId);
      }
    });
    
    return;
  }
  
  // Para coleções com paginação, seguimos com a filtragem normal
  console.log('Coleção com paginação: filtrando produtos fora de estoque para exibição posterior.');
  
  // Separar produtos em estoque e fora de estoque
  var outOfStockItems = productItems.filter(isProductOutOfStock);
  var inStockItems = productItems.filter(function(node) {
    return !isProductOutOfStock(node);
  });
  
  // Registrar todos os produtos como já carregados para evitar duplicação
  productItems.forEach(function(item) {
    var productId = item.getAttribute('data-product-id');
    if (productId && loadedProductIds) {
      loadedProductIds.add(productId);
    }
  });
  
  // Armazenar produtos fora de estoque para exibição posterior
  outOfStockProducts = outOfStockProducts.concat(outOfStockItems);
  
  // Remover produtos fora de estoque do DOM
  outOfStockItems.forEach(function(item) {
    item.parentNode.removeChild(item);
  });
  
  // Se não há produtos em estoque disponíveis, desativar o carregamento de produtos em estoque
  if (inStockItems.length === 0) {
    stillLoadingInStockProducts = false;
    
    // Recolocar produtos fora de estoque no DOM, já que não há produtos em estoque
    outOfStockProducts.forEach(function(node) {
      productsContainer.appendChild(node);
    });
    
    outOfStockProducts = []; // Limpar a lista
  }
};

// Função para ordenar produtos dentro de uma página específica
var sortProductsByAvailabilityInPage = function sortProductsByAvailabilityInPage(pageId) {
  var productsContainer = document.querySelector('.collection-base__body-products');
  
  if (!productsContainer) {
    return;
  }
  
  // Selecionar apenas os produtos da página específica
  var productItems = Array.from(productsContainer.querySelectorAll('.collection-base__body-product[data-page-id="' + pageId + '"]'));
  
  if (productItems.length === 0) {
    return;
  }
  
  // Ordenar produtos desta página: disponíveis primeiro, esgotados por último
  productItems.sort(function(a, b) {
    var aSoldOut = a.getAttribute('data-product-soldout') === 'true';
    var bSoldOut = b.getAttribute('data-product-soldout') === 'true';
    
    if (aSoldOut && !bSoldOut) return 1;  // a vai para o final
    if (!aSoldOut && bSoldOut) return -1; // b vai para o final
    return 0; // mantém a ordem original para itens com o mesmo status
  });
  
  // Encontrar o último item desta página para inserir antes dele
  var lastItemIndex = -1;
  var allProducts = Array.from(productsContainer.querySelectorAll('.collection-base__body-product'));
  for (var i = allProducts.length - 1; i >= 0; i--) {
    if (allProducts[i].getAttribute('data-page-id') === pageId) {
      lastItemIndex = i;
      break;
    }
  }
  
  // Se encontrou o último item, reordenar os produtos da página
  if (lastItemIndex >= 0) {
    var referenceNode = allProducts[lastItemIndex].nextSibling;
    // Reordenar no DOM mantendo a ordem das páginas
    productItems.forEach(function(item) {
      productsContainer.insertBefore(item, referenceNode);
    });
  }
};

// Função original para compatibilidade - agora ordena apenas a primeira página (carregamento inicial)
var sortProductsByAvailability = function sortProductsByAvailability() {
  var productsContainer = document.querySelector('.collection-base__body-products');
  
  if (!productsContainer) {
    return;
  }
  
  // Atribuir um ID de página para os produtos iniciais que não têm
  var initialPageId = 'initial-page';
  var productItems = Array.from(productsContainer.querySelectorAll('.collection-base__body-product:not([data-page-id])'));
  
  if (productItems.length === 0) {
    return;
  }
  
  // Marcar produtos da página inicial
  productItems.forEach(function(item) {
    item.setAttribute('data-page-id', initialPageId);
  });
  
  // Ordenar produtos da página inicial
  sortProductsByAvailabilityInPage(initialPageId);
};

// Variável para controlar o estado da ordenação
var sortingInProgress = false;
var lastSortTime = 0;
var sortCooldown = 1000; // 1 segundo de cooldown entre ordenações

// Configurar observador de mutação para detectar quando produtos são adicionados
var setupProductSortingObserver = function() {
  // Função para verificar se elementos foram adicionados à página
  var observer = new MutationObserver(function(mutations) {
    // Ignorar mutações se uma ordenação estiver em andamento ou se o cooldown não tiver passado
    if (sortingInProgress || (Date.now() - lastSortTime < sortCooldown)) {
      return;
    }
    
    var productListModified = false;
    
    // Verificar se alguma mutação afetou a estrutura da lista de produtos
    // Verificar apenas mutações significativas, ignorando hover states
    mutations.forEach(function(mutation) {
      // Só reagir se for adição/remoção de nós (não mutações de atributos)
      if (mutation.type === 'childList' && 
          // E se for na lista de produtos principal, não em subelementos como hover states
          (mutation.target.classList.contains('collection-base__body-products')) && 
          // E se os nós adicionados/removidos forem produtos (não outros elementos)
          (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
        
        // Verificar se as mutações são realmente produtos
        var hasProductChanges = false;
        
        if (mutation.addedNodes.length > 0) {
          Array.from(mutation.addedNodes).forEach(function(node) {
            if (node.classList && node.classList.contains('collection-base__body-product')) {
              hasProductChanges = true;
            }
          });
        }
        
        if (mutation.removedNodes.length > 0) {
          Array.from(mutation.removedNodes).forEach(function(node) {
            if (node.classList && node.classList.contains('collection-base__body-product')) {
              hasProductChanges = true;
            }
          });
        }
        
        if (hasProductChanges) {
          productListModified = true;
        }
      }
    });
    
    if (productListModified) {
      // Usar setTimeout para dar tempo ao DOM de ser atualizado completamente
      setTimeout(function() {
        sortingInProgress = true;
        lastSortTime = Date.now();
        sortProductsByAvailability();
        sortingInProgress = false;
      }, 100);
    }
  });
  
  // Iniciar observação do documento
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false  // Não observar mudanças de atributos (como classes de hover)
  });
  
  // Chamar ordenamento inicial após um curto timeout
  setTimeout(function() {
    sortingInProgress = true;
    lastSortTime = Date.now();
    sortProductsByAvailability();
    sortingInProgress = false;
  }, 300);
};

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupProductSortingObserver);
} else {
  setupProductSortingObserver();
}

// Modificar as funções de atualização de produtos para garantir a reordenação
var originalUpdateProductsListFromUrl = updateProductsListFromUrl;
updateProductsListFromUrl = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url) {
    var result;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return originalUpdateProductsListFromUrl(url);
          case 2:
            result = _context4.sent;
            // Não precisamos ordenar novamente, pois isso já é feito na nova implementação
            return _context4.abrupt("return", result);
          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x4) {
    return _ref4.apply(this, arguments);
  };
}();

// Não precisamos mais substituir a função addProductsTilesFromUrl pois já a modificamos diretamente

var initShowMoreProducts = function initShowMoreProducts() {
  // Chamamos o infinite scroll ao invés do comportamento original
  initInfiniteScroll();
};

var initInfiniteScroll = function initInfiniteScroll() {
  // Verificar se a coleção tem paginação antes de ativar o infinite scroll
  var productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
  var nextUrl = productsContainer ? productsContainer.getAttribute(NEXT_PRODUCTS_LIST_URL_ATTR) : null;
  
  // Se não houver próxima URL, significa que a coleção não tem paginação
  // Nesse caso, não ativamos o infinite scroll
  if (!nextUrl) {
    console.log('Coleção sem paginação detectada. Infinite scroll não será ativado.');
    return;
  }
  
  // Remover o botão de load more, já que será substituído pelo scroll infinito
  var loadMoreContainer = document.querySelector('.collection-base__body-more');
  if (loadMoreContainer) {
    loadMoreContainer.style.display = 'none';
  }
  
  // Criar um observador de interseção para detectar quando o usuário chega ao final da página
  var options = {
    root: null, // viewport
    rootMargin: '0px 0px 200px 0px', // disparar 200px antes do final
    threshold: 0.1
  };
  
  // Criar um elemento sentinela para detectar o final da página
  var sentinel = document.createElement('div');
  sentinel.className = 'infinite-scroll-sentinel';
  sentinel.style.height = '1px';
  sentinel.style.width = '100%';
  
  var productsContainer = document.querySelector(PRODUCTS_CONTAINER_SELECTOR);
  if (productsContainer) {
    // Adicionar o elemento sentinela após o container de produtos
    productsContainer.parentNode.insertBefore(sentinel, productsContainer.nextSibling);
    
    // Função para carregar mais produtos quando o scroll chegar ao final
    var loadMoreProducts = function() {
      // Se já estamos carregando produtos ou se todos já foram carregados, não fazer nada
      if (isLoadingProducts || allProductsLoaded) {
        return;
      }
      
      isLoadingProducts = true;
      
      // Mostrar algum indicador de carregamento (opcional)
      var loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'infinite-scroll-loading';
      loadingIndicator.innerHTML = '<div class="loading-spinner"></div>';
      productsContainer.parentNode.insertBefore(loadingIndicator, sentinel);
      
      var nextUrl = productsContainer.getAttribute(NEXT_PRODUCTS_LIST_URL_ATTR);
      if (!nextUrl) {
        // Se não há próxima URL, mas temos produtos fora de estoque para mostrar,
        // devemos mostrar esses produtos
        if (outOfStockProducts.length > 0 && stillLoadingInStockProducts) {
          stillLoadingInStockProducts = false;
          
          // Não retornamos aqui, permitimos que o código continue para mostrar os produtos fora de estoque
        } else {
          // Se não temos mais URLs e não temos produtos fora de estoque para mostrar,
          // então realmente acabamos
          isLoadingProducts = false;
          allProductsLoaded = true;
          
          // Remover o indicador de carregamento
          if (loadingIndicator) {
            loadingIndicator.parentNode.removeChild(loadingIndicator);
          }
          return;
        }
      }
      
      // Carregar mais produtos
      addProductsTilesFromUrl(nextUrl).then(function(sectionBody) {
        // Atualizar a próxima URL ou marcar como todos carregados se não houver mais
        var nextUrl = updateNextUrlValue(sectionBody);
        
        // Se não há próxima URL e não há mais produtos em estoque para mostrar,
        // vamos exibir os produtos fora de estoque
        if (!nextUrl) {
          stillLoadingInStockProducts = false;
          
          // Se não temos mais produtos fora de estoque para mostrar, terminamos
          if (outOfStockProducts.length === 0) {
            allProductsLoaded = true;
          } else {
            // Precisamos carregar os produtos fora de estoque, então não terminamos ainda
            allProductsLoaded = false;
          }
        }
        
        // Remover o indicador de carregamento
        if (loadingIndicator) {
          loadingIndicator.parentNode.removeChild(loadingIndicator);
        }
        
        // Permitir carregar mais produtos
        isLoadingProducts = false;
      }).catch(function(error) {
        console.error('Erro ao carregar mais produtos:', error);
        isLoadingProducts = false;
        
        // Remover o indicador de carregamento em caso de erro
        if (loadingIndicator) {
          loadingIndicator.parentNode.removeChild(loadingIndicator);
        }
      });
    };
    
    // Criar observador para o scroll infinito
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    }, options);
    
    // Iniciar observação do elemento sentinela
    observer.observe(sentinel);
  }
};
var toggleCollectionSideMenu = function toggleCollectionSideMenu(isActive) {
  overlay.setAttribute(ACTIVE_ATTR, "".concat(isActive));
  sideMenu.setAttribute(ACTIVE_ATTR, "".concat(isActive));
  document.body.classList.toggle('overflow-hidden');
};
var initCollectionSideMenu = function initCollectionSideMenu() {
  var closeCollectionSideMenuEls = document.querySelectorAll(SIDE_MENU_HIDE_ACTION);
  closeCollectionSideMenuEls.forEach(function (closeEl) {
    closeEl.addEventListener('click', function () {
      toggleCollectionSideMenu(false);
    });
  });
  var openCollectionSideMenuEls = document.querySelectorAll(SIDE_MENU_SHOW_ACTION);
  openCollectionSideMenuEls.forEach(function (openEl) {
    openEl.addEventListener('click', function () {
      toggleCollectionSideMenu(true);
    });
  });
};
var applyFilter = function applyFilter() {
  enableLoadingOverlay();
  var url = makeUrlWithFilters();
  updateProductsListFromUrl(url).then(function (page) {
    updateNextUrlValue(page);
    updateSideMenuState(page);
    window.history.replaceState({}, '', url);
    disableLoadingOverlay();
  });
};
var initApplyAllFilters = function initApplyAllFilters() {
  var applyFilterBtn = document.querySelector("".concat(APPLY_ACTIVE_FILTERS_ACTION));
  applyFilterBtn === null || applyFilterBtn === void 0 ? void 0 : applyFilterBtn.addEventListener('click', function () {
    applyFilter();
    toggleCollectionSideMenu(false);
  });
};
var getActiveFiltersList = function getActiveFiltersList() {
  return _toConsumableArray(document.querySelectorAll("".concat(FILTER_ACTION, "[data-checked=\"true\"]"))) || [];
};
var getActiveSortNode = function getActiveSortNode() {
  return document.querySelector("".concat(SIDE_MENU_SORTING_RULE_SELECTOR, "[data-active=\"true\"]"));
};
var getPriceNodes = function getPriceNodes() {
  return _toConsumableArray(document.querySelectorAll(PRICE_RANGE_SELECTOR));
};
var makeFiltersURLParams = function makeFiltersURLParams() {
  var activeFiltersNodes = getActiveFiltersList();
  var booleanFilters = activeFiltersNodes.map(function (node) {
    var name = node.getAttribute('name');
    var value = node.value.replaceAll(' ', '+').replaceAll('&', '%26');
    return "".concat(name, "=").concat(value);
  });
  var priceInputs = getPriceNodes();
  var priceFilters = priceInputs.map(function (priceInput) {
    var name = priceInput.getAttribute('name');
    var value = priceInput.value.replaceAll(',', '');
    return value || value === '0' ? "".concat(name, "=").concat(value) : '';
  }).filter(Boolean);
  return booleanFilters.concat.apply(booleanFilters, _toConsumableArray(priceFilters));
};
var makeSortingUrlParam = function makeSortingUrlParam() {
  var activeSortingNode = getActiveSortNode();
  var activeSortingValue = activeSortingNode.getAttribute(VALUE_ATTR);
  return activeSortingValue ? "sort_by=".concat(activeSortingNode.getAttribute(VALUE_ATTR)) : '';
};
var makeUrlWithFilters = function makeUrlWithFilters() {
  var activeFiltersUrlParams = makeFiltersURLParams();
  var activeSortingUrlParam = makeSortingUrlParam();
  var urlParams = activeFiltersUrlParams.concat(activeSortingUrlParam).join('&');
  var url = "".concat(location.pathname, "?").concat(urlParams);
  return url;
};
var initSorting = function initSorting() {
  var sortingButtons = document.querySelectorAll("".concat(SIDE_MENU_SORTING_RULE_SELECTOR));
  var searchParams = new URLSearchParams(window.location.search);
  var sortUrlParamValue = searchParams.get('sort_by');
  sortingButtons.forEach(function (sortingButton) {
    var sortingParams = sortingButton.getAttribute('data-values');
    if (sortUrlParamValue) {
      if (sortingParams.includes(sortUrlParamValue)) {
        sortingButton.setAttribute(ACTIVE_ATTR, 'true');
      }
    } else if (sortingParams === 'manual') {
      sortingButton.setAttribute(ACTIVE_ATTR, 'true');
    }
    sortingButton.addEventListener('click', function () {
      sortingButtons.forEach(function (btn) {
        return btn.setAttribute(ACTIVE_ATTR, 'false');
      });
      sortingButton.setAttribute(ACTIVE_ATTR, 'true');
      var sortingValuesArr = sortingButton.getAttribute('data-values').split(' ');
      if (sortingValuesArr.length > 1) {
        var oldSortingValue = sortingButton.getAttribute(VALUE_ATTR);
        var newSortingValue = sortingValuesArr.find(function (sortingValue) {
          return sortingValue !== oldSortingValue;
        });
        sortingButton.setAttribute(VALUE_ATTR, newSortingValue);
      }
      applyFilter();
    });
  });
};
var initFilters = function initFilters() {
  var filters = document.querySelectorAll(FILTER_ACTION);
  filters.forEach(function (filter) {
    filter.addEventListener('click', function () {
      var activeRemoveFilterBtn = document.querySelector("[".concat(ACTIVES_FILTER_PARAM_NAME_ATTR, "=\"").concat(filter.name, "\"][").concat(ACTIVES_FILTER_PARAM_VALUE_ATTR, "=\"").concat(filter.value, "\"]"));
      if (filter.getAttribute('data-checked') === 'true') {
        filter.setAttribute('data-checked', 'false');
        activeRemoveFilterBtn.setAttribute('data-active', 'false');
        calcSelectedFiltersNumber(filter.name, false);
      } else {
        filter.setAttribute('data-checked', 'true');
        activeRemoveFilterBtn.setAttribute('data-active', 'true');
        calcSelectedFiltersNumber(filter.name, true);
      }
    });
  });
};
var toggleActiveRemoveFilterPrice = function toggleActiveRemoveFilterPrice(isActive) {
  removePriceFilterBtnEl.setAttribute('data-active', "".concat(isActive));
};
var initPriceFilters = function initPriceFilters() {
  var _urlSearch = "".concat(location.pathname, "?view=price.json").replace('??', '?').replace('&&', '&');
  fetch(_urlSearch).then(function (response) {
    if (response.ok) {
      return response.json();
    }
  }).then(function (data) {
    var minPriceRangeInput = document.querySelector(PRICE_RANGE_MIN_SELECTOR);
    var minSelected = minPriceRangeInput.value ? minPriceRangeInput.value / 100 : 0;
    var maxPriceRangeInput = document.querySelector(PRICE_RANGE_MAX_SELECTOR);
    var maxSelected = maxPriceRangeInput.value !== '' ? maxPriceRangeInput.value / 100 : data.collection.priceMax;
    priceRangeFromEl.setAttribute('placeholder', "$".concat(minSelected));
    priceRangeToEl.setAttribute('placeholder', "$".concat(maxSelected));
    window.$(PRICE_RANGE_CONTAINER_SELECTOR).slider({
      range: true,
      min: 0,
      max: data.collection.priceMax,
      values: [minSelected, maxSelected],
      slide: function slide(event, ui) {
        // convert 1960 to 1,960
        var min = ui.values[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var max = ui.values[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        priceRangeFromEl.value = "$".concat(min);
        priceRangeToEl.value = "$".concat(max);
        removePriceFilterBtnTextEl.textContent = "$".concat(min, " - $").concat(max);
      },
      change: function change() {
        toggleActiveRemoveFilterPrice(true);
      }
    });
  });
};
var initRemoveFilterBtns = function initRemoveFilterBtns() {
  removeFiltersBtns.forEach(function (removeFilterBtn) {
    removeFilterBtn.addEventListener('click', function () {
      var paramName = removeFilterBtn.getAttribute(ACTIVES_FILTER_PARAM_NAME_ATTR);
      var paramValue = removeFilterBtn.getAttribute(ACTIVES_FILTER_PARAM_VALUE_ATTR);
      var selectedFilterCheckbox = document.querySelector("".concat(FILTER_ACTION, "[data-checked=\"true\"][name=\"").concat(paramName, "\"][value=\"").concat(paramValue, "\"]"));
      selectedFilterCheckbox.setAttribute('data-checked', 'false');
      removeFilterBtn.setAttribute('data-active', 'false');
      calcSelectedFiltersNumber(paramName, false);
      applyFilter();
    });
  });
};
var resetPriceRange = function resetPriceRange() {
  var minPriceRangeInput = document.querySelector(PRICE_RANGE_MIN_SELECTOR);
  var maxPriceRangeInput = document.querySelector(PRICE_RANGE_MAX_SELECTOR);
  minPriceRangeInput.value = '';
  maxPriceRangeInput.value = '';
  var priceRanges = document.querySelectorAll(PRICE_RANGE_SELECTOR);
  priceRanges.forEach(function (priceRange) {
    priceRange.value = '';
  });
  window.$(PRICE_RANGE_CONTAINER_SELECTOR).each(function () {
    var options = window.$(this).slider("option");
    window.$(this).slider("values", [options.min, options.max]);
  });
  toggleActiveRemoveFilterPrice(false);
};
var deactivateRemoveFiltersBtn = function deactivateRemoveFiltersBtn() {
  removeFiltersBtns.forEach(function (removeFiltersBtn) {
    removeFiltersBtn.setAttribute('data-active', 'false');
  });
};
var initRemovePriceFilterBtn = function initRemovePriceFilterBtn() {
  removePriceFilterBtnEl === null || removePriceFilterBtnEl === void 0 ? void 0 : removePriceFilterBtnEl.addEventListener('click', function () {
    resetPriceRange();
    applyFilter();
  });
};
var initClearAllFilters = function initClearAllFilters() {
  var clearFiltersBtn = document.querySelector(REMOVE_ACTIVE_FILTERS_ACTION);
  clearFiltersBtn === null || clearFiltersBtn === void 0 ? void 0 : clearFiltersBtn.addEventListener('click', function () {
    var activeFiltersList = getActiveFiltersList();
    activeFiltersList.forEach(function (activeFilter) {
      activeFilter.setAttribute('data-checked', 'false');
    });
    resetPriceRange();
    deactivateRemoveFiltersBtn();
    calcSelectedFiltersNumber('', false, true);
    applyFilter();
  });
};
var calcSelectedFiltersNumber = function calcSelectedFiltersNumber(filterName, isAdd) {
  var isClearAllClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  filtersHeaders.forEach(function (filtersHeader) {
    if (isClearAllClick) {
      filtersHeader.setAttribute('data-value', '0');
    } else {
      var filterId = filtersHeader.getAttribute('data-filter-id');
      if (filtersHeader && filterId === filterName) {
        var defaultCountOfSelectedFilters = Number(filtersHeader.getAttribute('data-value'));
        filtersHeader.setAttribute('data-value', "".concat(isAdd ? defaultCountOfSelectedFilters + 1 : defaultCountOfSelectedFilters - 1));
      }
    }
  });
};
var updateSideMenuState = function updateSideMenuState(page) {
  var _page$querySelector, _document$querySelect2;
  // Count of products
  var productsCount = ((_page$querySelector = page.querySelector(SIDE_MENU_TITLE_SELECTOR)) === null || _page$querySelector === void 0 ? void 0 : _page$querySelector.getAttribute(VALUE_ATTR)) || 0;
  (_document$querySelect2 = document.querySelector(SIDE_MENU_TITLE_SELECTOR)) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.setAttribute(VALUE_ATTR, productsCount);

  // Filters availability
  var newFiltersItemsLabels = _toConsumableArray(page.querySelectorAll(FILTER_VALUE_LABEL_SELECTOR));
  var oldFiltersItemsLabels = document.querySelectorAll(FILTER_VALUE_LABEL_SELECTOR);
  oldFiltersItemsLabels.forEach(function (oldFilterItemLabel) {
    var newFilterItemLabel = newFiltersItemsLabels.find(function (newFilterItemLabel) {
      return newFilterItemLabel.getAttribute('for') === oldFilterItemLabel.getAttribute('for');
    });
    if (newFilterItemLabel) {
      if (newFilterItemLabel.classList.contains('disabled')) {
        oldFilterItemLabel.classList.add('disabled');
        oldFilterItemLabel.querySelector('input').setAttribute('disabled', 'disabled');
      } else {
        oldFilterItemLabel.classList.remove('disabled');
        oldFilterItemLabel.querySelector('input').removeAttribute('disabled');
      }
    }
  });
};
// Função mantida para compatibilidade, mas não será mais usada com o scroll infinito
var hideShowMoreProductsButton = function hideShowMoreProductsButton() {
  // Não faz nada, já que usamos scroll infinito agora
};
var initNav = function initNav() {
  var scrolledNavContainer = document.querySelector("[".concat(HEADER_NAV_ATTR, "]"));
  var scrolledNavList = scrolledNavContainer.querySelector('ul');
  var checkPosition = function checkPosition() {
    var isLeftScroll = scrolledNavContainer.scrollLeft > 0;
    var isRightScroll = Math.round(scrolledNavContainer.scrollLeft) < scrolledNavList.scrollWidth - scrolledNavContainer.clientWidth;
    if (isLeftScroll && isRightScroll) {
      scrolledNavContainer.setAttribute('data-scroll-side', 'both');
    } else if (isLeftScroll) {
      scrolledNavContainer.setAttribute('data-scroll-side', 'left');
    } else if (isRightScroll) {
      scrolledNavContainer.setAttribute('data-scroll-side', 'right');
    } else {
      scrolledNavContainer.setAttribute('data-scroll-side', 'none');
    }
  };
  scrolledNavContainer.addEventListener('scroll', function () {
    checkPosition();
  });
};
var lastScrollY = window.scrollY;
var isScrollDown = function isScrollDown() {
  var currentScrollY = window.scrollY;
  var result = currentScrollY > lastScrollY;
  lastScrollY = currentScrollY;
  return result;
};
var initStickyFilterButton = function initStickyFilterButton() {
  var collectionBaseHeader = document.querySelector('[data-collection-base-header]');
  var collectionFilterBtn = document.querySelector('[data-collection-base-header-filter-btn]');
  if (!collectionBaseHeader || !collectionFilterBtn) return;
  var header = document.querySelector('#header');
  var announcementBar = document.querySelector('[data-section="announcement-bar"]');
  var filterScrollThreshold = Number(collectionFilterBtn.getAttribute('data-filter-scroll-threshold')) || 0;
  function setStickyFilterBtn() {
    if (collectionFilterBtn.offsetHeight === 0) return;
    var announcementBarHeight = (announcementBar === null || announcementBar === void 0 ? void 0 : announcementBar.offsetHeight) || 0;
    var filterBtnOffset = collectionBaseHeader.offsetHeight + header.offsetHeight + announcementBarHeight;
    var isFixedFilter = window.scrollY > filterBtnOffset;
    var isVisibleFilter = window.scrollY > filterBtnOffset + filterScrollThreshold;
    var isHiddenHeader = header.getAttribute('data-hidden-header') === 'false';
    var filterTransformValue = isHiddenHeader && isVisibleFilter ? "".concat(header.offsetHeight, "px") : !isVisibleFilter && isFixedFilter ? '-100%' : '0';
    collectionFilterBtn.setAttribute('data-fixed', "".concat(isScrollDown() ? isFixedFilter && isVisibleFilter : isFixedFilter));
    collectionFilterBtn.style.transform = "translateY(".concat(filterTransformValue, ")");
  }
  window.addEventListener('scroll', setStickyFilterBtn, {
    passive: true
  });
};
document.addEventListener('DOMContentLoaded', function () {
  // Primeiro, filtrar produtos fora de estoque na carga inicial
  filterOutOfStockProductsOnInitialLoad();
  
  // Então inicializar os outros componentes
  initReadMoreDescription();
  initChangeGridButtons();
  initShowMoreProducts();
  initCollectionSideMenu();
  initSorting();
  initFilters();
  initNav();
  initRemoveFilterBtns();
  initRemovePriceFilterBtn();
  initClearAllFilters();
  initApplyAllFilters();
  initPriceFilters();
  initStickyFilterButton();
});
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;